import React, { useState, useEffect } from 'react'
import { Tabs, Tab, LinearProgress } from '@mui/material'
import { Box } from '@mui/system'
import EventRelatory from './EventRelatory'
import AlarmRelatory from './AlarmRelatory'
import RegisterRelatory from './RegisterRelatory'
import AmplifierRelatory from './AmplifierRelatory'
import { Typography } from '@mui/material'
import PropTypes from 'prop-types'
import AmplifierStatusRelatory from './AmplifierStatusRelatory'
import PanelStatusRelatory from './PanelStatusRelatory'
import { Height } from '@mui/icons-material'

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            className="tab__item"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function Relatory(props) {
    //function getValidUser(propsUser) {
    //    console.log("PROP USER ON ENTERING REPORT: ", propsUser);
    //    if (propsUser && Object.keys(propsUser).length > 0) {
    //        return propsUser;
    //    }
    //    try {
    //        const localUser = localStorage.getItem('user');
    //        if (localUser) {
    //            const parsed = JSON.parse(localUser);
    //            if (parsed && Object.keys(parsed).length > 0) {
    //                return parsed;
    //            }
    //        }
    //    } catch { }
    //    return null;
    //}

    //const user = getValidUser(props.user);
    const [value, setValue] = useState(0)
    const [isLoading, setIsLoading] = useState(false);


    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    return (
        <div className="container" style={{ paddingTop: '1.5rem', paddingBottom: '2rem' }}>
            <>
                {isLoading &&
                    <LinearProgress 
                        color="secondary" 
                        sx={{ 
                            position: "fixed", 
                            top: "0", 
                            left: "0", 
                            width: "100%", 
                            zIndex: "1201",
                            height: '4px'
                        }} 
                    />
                }
                {props.serial && props.user.roles.light === false
                    ?
                    <Tabs 
                        TabIndicatorProps={{ 
                            sx: { 
                                backgroundColor: '#3498DB', 
                                height: '5px',
                                borderRadius: '4px 4px 0 0'
                            } 
                        }} 
                        value={value} 
                        onChange={handleChange} 
                        centered
                        sx={{
                            '& .MuiTabs-flexContainer': {
                                flexWrap: 'wrap',
                            },
                            position: "sticky",
                            top: 0,
                            background: 'linear-gradient(135deg, #1a252f 0%, #2C3E50 100%)',
                            zIndex: 2,
                            borderBottom: '3px solid #3498DB',
                            borderRadius: '20px 20px 0 0',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                            '& .MuiTab-root': {
                                color: '#7F8C8D',
                                fontWeight: 500,
                                textTransform: 'none',
                                minHeight: '56px',
                                fontSize: '0.875rem',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&.Mui-selected': {
                                    color: '#FFF',
                                    fontWeight: 700,
                                    backgroundColor: 'rgba(52, 152, 219, 0.25)',
                                    textShadow: '0 0 10px rgba(52, 152, 219, 0.8)',
                                    borderRadius: '12px 12px 0 0'
                                },
                                '&:hover': {
                                    color: '#BDC3C7',
                                    transform: 'translateY(-2px)',
                                    backgroundColor: 'rgba(52, 152, 219, 0.1)'
                                }
                            }
                        }}
                    >
                        <Tab sx={{ fontSize: '0.7rem' }} label="Eventos" {...a11yProps(0)} />
                        <Tab sx={{ fontSize: '0.7rem' }} label="Alarmes" {...a11yProps(1)} />
                        <Tab sx={{ fontSize: '0.7rem' }} label="Perif&eacute;ricos" {...a11yProps(2)} />
                        <Tab sx={{ fontSize: '0.7rem' }} label="Amplificadores" {...a11yProps(3)} />
                        <Tab sx={{ fontSize: '0.7rem' }} label="Status Amplif." {...a11yProps(4)} />
                        <Tab sx={{ fontSize: '0.7rem' }} label="Status Central" {...a11yProps(5)} />
                    </Tabs>
                    :
                    <Tabs 
                        TabIndicatorProps={{ 
                            sx: { 
                                backgroundColor: '#3498DB', 
                                height: '4px',
                                borderRadius: '4px 4px 0 0'
                            } 
                        }} 
                        value={value} 
                        onChange={handleChange} 
                        centered
                        sx={{
                            position: "sticky",
                            top: 0,
                            background: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)',
                            zIndex: 2,
                            borderBottom: '3px solid #3498DB',
                            borderRadius: '20px 20px 0 0',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                            '& .MuiTab-root': {
                                color: '#95A5A6',
                                fontWeight: 500,
                                textTransform: 'none',
                                minHeight: '56px',
                                fontSize: '0.875rem',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&.Mui-selected': {
                                    color: '#ECF0F1',
                                    fontWeight: 700,
                                    textShadow: '0 0 10px rgba(52, 152, 219, 0.5)'
                                },
                                '&:hover': {
                                    color: '#BDC3C7',
                                    transform: 'translateY(-2px)'
                                }
                            }
                        }}
                    >
                        <Tab label="Eventos" {...a11yProps(0)} />
                        <Tab label="Alarmes" {...a11yProps(1)} />
                    </Tabs>
                }
            </>
            {props.serial
                ?
                <>
                    <TabPanel value={value} index={0}>
                        <EventRelatory isLoading={isLoading} setIsLoading={setIsLoading} serial={props.serial} user={props.user} menuItens={props.menuItens} token={props.token} />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <AlarmRelatory isLoading={isLoading} setIsLoading={setIsLoading} serial={props.serial} user={props.user} menuItens={props.menuItens} token={props.token} />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <RegisterRelatory isLoading={isLoading} setIsLoading={setIsLoading} serial={props.serial} user={props.user} token={props.token} />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <AmplifierRelatory isLoading={isLoading} setIsLoading={setIsLoading} serial={props.serial} user={props.user} token={props.token} />
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        <AmplifierStatusRelatory isLoading={isLoading} setIsLoading={setIsLoading} serial={props.serial} user={props.user} menuItens={props.menuItens} token={props.token} />
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                        <PanelStatusRelatory isLoading={isLoading} setIsLoading={setIsLoading} serial={props.serial} user={props.user} menuItens={props.menuItens} token={props.token} />
                    </TabPanel>
                </>
                :
                <>
                    <TabPanel value={value} index={0}>
                        <EventRelatory isLoading={isLoading} setIsLoading={setIsLoading} serial={props.serial} user={props.user} menuItens={props.menuItens} token={props.token} />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <AlarmRelatory isLoading={isLoading} setIsLoading={setIsLoading} serial={props.serial} user={props.user} menuItens={props.menuItens} token={props.token} />
                    </TabPanel>
                </>
            }
        </div>
    )
}